import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=b7020902&scoped=true"
import script from "./IdCard.vue?vue&type=script&lang=js"
export * from "./IdCard.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./IdCard.vue?vue&type=style&index=0&id=b7020902&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./IdCard.vue?vue&type=style&index=1&id=b7020902&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b7020902",
  "5f731d9a"
  
)

export default component.exports